import debounce from 'hs-lodash/debounce';
import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'data-fetching-client';
// @ts-expect-error no type declarations yet
import { fetchMeetingsUsers } from 'MeetingsAdmin/redux/actions/MeetingsUserActions';
// @ts-expect-error no type declarations yet
import { getUser } from 'MeetingsAdmin/selectors/AuthSelector';
import batchUsersQuery from '../../query/batchUsersQuery';
import { ALL_MEETINGS_USERS } from '../../constants/enums';
import { getDisplayNameForUser, getViewerIsOwnerIndicator
// @ts-expect-error no type declarations yet
} from 'MeetingsAdmin/selectors/MeetingsUsersSelectors';
import Raven from 'raven-js';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Select } from 'foundations-components/transitional/components/Select';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function HubSpotUserSelect({
  value,
  onChange,
  multi,
  groupUsersOnly = false,
  showAllUsersOption = false,
  filterUserId,
  error,
  placeholder,
  valueComponent,
  disabled = false,
  buttonUse,
  noResultsText,
  searchPromptText,
  searchPlaceholder,
  menuWidth,
  'data-test-id': dataTestId
}) {
  const valueArray = useMemo(() => {
    if (Array.isArray(value)) {
      return value;
    }
    if (!value) {
      return [];
    }
    return [value];
  }, [value]);
  const currentOwner = useSelector(state => getUser(state));
  const {
    data: hubSpotUsers
  } = useQuery(batchUsersQuery, {
    variables: {
      userIds: valueArray
    }
  });
  const valueOptions = useMemo(() => {
    const hubSpotUserIdToValueObject = userId => {
      const user = hubSpotUsers && hubSpotUsers.batchUsers[userId];
      if (!user) {
        return userId;
      }
      const viewerIsOwner = userId === currentOwner.user_id;
      const displayName = getDisplayNameForUser(user);
      return {
        text: viewerIsOwner ? `${displayName} ${getViewerIsOwnerIndicator()}` : displayName,
        value: user.user_id,
        email: user.email
      };
    };
    if (Array.isArray(value)) {
      return value.map(hubSpotUserIdToValueObject);
    }
    return hubSpotUserIdToValueObject(value);
  }, [value, hubSpotUsers, currentOwner]);
  const handleChange = useCallback(event => {
    const newValue = event.target.value;
    return Array.isArray(newValue) ? onChange(newValue.map(option => option.value)) : onChange(newValue.value);
  }, [onChange]);
  const debounceLoadOptions = useMemo(() => {
    return debounce((input, callback, pagination = {
      offset: 0,
      allResults: showAllUsersOption ? [{
        text: 'All users',
        value: ALL_MEETINGS_USERS
      }] : []
    }) => {
      fetchMeetingsUsers(input, currentOwner, filterUserId, groupUsersOnly, pagination.offset).then(apiResults => {
        const {
          results,
          hasMore,
          offset,
          total
        } = apiResults;
        const existingResultsSet = pagination.allResults.reduce((setAcc, meetingsUser) => {
          if (!setAcc.has(meetingsUser.value)) {
            setAcc.add(meetingsUser.value);
          }
          return setAcc;
        }, new Set());
        const allResults = [...pagination.allResults, ...results.filter(currentOption => !existingResultsSet.has(currentOption.value))];
        callback(null, {
          options: allResults,
          pagination: {
            hasMore,
            length: total,
            offset,
            allResults
          }
        });
      }).catch(err => {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "notifications.errorFetchingUsers"
          }),
          type: 'danger'
        });
        Raven.captureException(err, {
          level: 'critical'
        });
      });
    }, 500);
  }, [currentOwner, filterUserId, groupUsersOnly, showAllUsersOption]);
  return /*#__PURE__*/_jsx(Select, {
    buttonUse: buttonUse,
    disabled: disabled,
    value: valueOptions,
    onSelectedOptionChange: handleChange,
    multi: multi,
    error: error,
    placeholder: placeholder,
    valueComponent: valueComponent,
    loadOptions: debounceLoadOptions,
    noResultsText: noResultsText,
    searchPromptText: searchPromptText,
    searchPlaceholder: searchPlaceholder,
    menuWidth: menuWidth,
    "data-test-id": dataTestId
  });
}
export default HubSpotUserSelect;